import { isFunction, isUndefined } from 'lodash-es';

import { XYChartData } from '../types/xy-chart.js';

/**
 * Generic function that evaluates a value or function with data context
 * @param valueOrFn Value or function that returns a value
 * @param data Data context to pass to the function if valueOrFn is a function
 * @returns The value directly or the result of calling the function with data
 */
export const evaluateWithData = <T>(
  valueOrFn: T | ((data: unknown) => T),
  data: XYChartData,
): T => {
  if (!isFunction(valueOrFn)) {
    return valueOrFn;
  }

  return valueOrFn(data);
};

/**
 * Helper function to evaluate optional attributes with default values
 * @param value The optional value or function
 * @param data Data context to pass to the function if value is a function
 * @param defaultValue The default value to use if value is undefined
 * @returns The evaluated value or the default value if undefined
 */
export const evaluateOptionalAttribute = <T>(
  value: T | ((data: unknown) => T) | undefined,
  data: XYChartData,
  defaultValue: T,
): T => {
  if (isUndefined(value)) {
    return defaultValue;
  }

  return evaluateWithData(value, data);
};
